import { TYPES } from "./types";
import { sesProductQtyChangeService } from "../services";

export const getSESProductQtyChanges = (query) => async (dispatch) => {
  try {
    const result = await sesProductQtyChangeService.getSESProductQtyChanges(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_SES_PRODUCT_QTY_CHANGES_SUCCESS,
        payload: { data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_SES_PRODUCT_QTY_CHANGES_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const setSESProductQtyChanges = (dataChanges, query = {}) => async (dispatch) => {
  try {
    const result = await sesProductQtyChangeService.setSESProductQtyChanges(dataChanges, query);
    const data = result.data.data;
    
    if (data) {
      if (query.create_new) {
        dispatch({
          type: TYPES.ACTION_ADD_SES_PRODUCT_QTY_CHANGES_SUCCESS,
          payload: { data }
        });
      } else {
        dispatch({
          type: TYPES.ACTION_SET_SES_PRODUCT_QTY_CHANGES_SUCCESS,
          payload: { data }
        });
      }
    } else {
      dispatch({
        type: TYPES.ACTION_SET_SES_PRODUCT_QTY_CHANGES_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const sesProductQtyChangeAction = {
  getSESProductQtyChanges,
  setSESProductQtyChanges
}; 